import SignupShell from '../../../components/SignupShell';
import React, { useEffect, useRef, useState } from "react";
import HeaderText from "../../../common/HeaderText";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AlertMessage from "../../../common/AlertMessage";
import { otpVerifyFunc, resetCreatePassword } from "../../../actions/Auth";
import { LoadingButton } from "@mui/lab";

const useStyles = makeStyles((theme) => {
  return {
    otp_box: {
      "& input": {
        fontSize: "22px !important",
        padding: "12px",
        textAlign: "center",
      },
    },
  };
});

const OtpVerification = () => {
  const classes = useStyles();

  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [activeOtpIndex, setActiveOtpIndex] = useState(0);

  const inputRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const otpVerify = useSelector((state) => state.otpVerify);
  const { loading, error, res } = otpVerify;

  const [open, setOpen] = useState(false);
  const [moveToNext, setMoveToNext] = useState(false);

  const location = useLocation();

  // console.log("RES IN OTP VERIFICATION", res);

  // const state = location.state && location.state

  useEffect(() => {
    if (!error && res?.ok && location?.state?.createAgency && moveToNext) {
      navigate("/create-password", { state: { agent_data: res } });
      return;
    }
  }, [res]);

  useEffect(() => {
    if (!error && res?.ok && location?.state?.forgotPassword && moveToNext) {
      navigate("/reset-password", {
        state: { finalEmail: location?.state.email },
      });
      return;
    }
  }, [res, location]);

  useEffect(() => {
    if (location?.state === null) {
      navigate(-1);
    }
  }, [res, location, navigate]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const otpVerificationHandler = async (e) => {
    e.preventDefault();

    const otpNum = otp.join("");

    if (!/^[0-9]{6}$/.test(otpNum)) {
      return;
    }

    dispatch(resetCreatePassword());
    dispatch(otpVerifyFunc(location?.state?.email, otpNum));
    setOpen(true);
    setMoveToNext(true);
  };

  const otpChangeHandler = (e, index) => {
    const { value } = e.target;

    if (!/^[0-9]*$/.test(value)) {
      return;
    }

    // Browser code autofill supplies the whole code without a keydown event.
    if (value.length === otp.length) {
      setOtp(value.split(""));
      setActiveOtpIndex(otp.length - 1);
      return;
    }

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);
    setActiveOtpIndex(
      Math.max(0, Math.min(otp.length - 1, index + (value ? 1 : -1)))
    );
  };

  const keyDownHandler = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const targetIndex = otp[index] ? index : Math.max(0, index - 1);
      const newOtp = [...otp];
      newOtp[targetIndex] = "";
      setOtp(newOtp);
      setActiveOtpIndex(targetIndex);
    }
  };

  const pasteOtpHandler = (e) => {
    e.preventDefault();
    const pasteText = (e.clipboardData || window.clipboardData)
      .getData("text/plain")
      .trim();

    if (/^[0-9]{6}$/.test(pasteText)) {
      setOtp(pasteText.split(""));
      setActiveOtpIndex(otp.length - 1);
    }
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeOtpIndex]);

  if (location.state === null) {
    return;
  }

  return (
    <>
      {!loading && error && (
        <AlertMessage
          message={error}
          severity="error"
          open={open}
          handleClose={handleClose}
        />
      )}

      <SignupShell>

          <Grid container component="main">
            <Box
              component="form"
              id="email-verification-form"
              aria-label="Email verification"
              autoComplete="off"
              onSubmit={otpVerificationHandler}
              xs={12}
              display="flex"
              gap="52px"
              flexDirection="column"
              width="100%"
            >
              <Box>
                <HeaderText
                  variant="h3"
                  fontSize={34}
                  textContent="Enter the 6 digit code"
                  lineHeight="24px"
                  textAlign="center"
                />
                <Typography
                  variant="body1"
                  className="d-flex"
                  alignItems="center"
                  justifyContent="center"
                  fontSize={16}
                  mt="16px"
                  color="#566875"
                >
                  We've sent you a six digit code on your email
                </Typography>
              </Box>

              <Box width="100%" display="flex" alignItems="center" gap="16px">
                {otp.map((s, index) => (
                  <TextField
                    key={index}
                    id={`verification-code-${index + 1}`}
                    name={`verification-code-${index + 1}`}
                    inputRef={index === activeOtpIndex ? inputRef : null}
                    variant="outlined"
                    className={classes.otp_box}
                    type="text"
                    value={s}
                    autoComplete={index === 0 ? "one-time-code" : "off"}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]",
                      "aria-label": `Verification code digit ${index + 1} of 6`,
                      "data-1p-ignore": true,
                      "data-lpignore": "true",
                    }}
                    onChange={(e) => otpChangeHandler(e, index)}
                    onFocus={(e) => {
                      setActiveOtpIndex(index);
                      e.target.select();
                    }}
                    onKeyDown={(e) => keyDownHandler(e, index)}
                    onPaste={pasteOtpHandler}
                  />
                ))}
              </Box>

              <LoadingButton
                fullWidth
                loading={loading}
                type="submit"
                variant="contained"
                sx={{ padding: "8px 22px", fontSize: 15 }}
              >
                Continue
              </LoadingButton>

              {/* <Button
        className="w-100"
        fontSize="15px"
        color="primary"

        title="Sign In"
        variant="contained"
        width="100%"
        height="48px"
        // disabled={!fieldVals?.email || !fieldVals?.password} // Disabling it off on purpose
        // onClick={() => onSignIn()}
        // loading={signInLoading}
        loadingColor="primary"
      /> */}
            </Box>
          </Grid>
        </SignupShell>
    </>
  );
};

export default OtpVerification;
